import React, { forwardRef } from "react";

const Select = forwardRef(function Input({ children, hasError, ...props }, ref) {
    return (
        <select
            ref={ref}
            className={`tw-block tw-w-full tw-rounded-md tw-border-0 tw-px-2 tw-py-2 tw-text-gray-800 tw-ring-1 tw-ring-inset ${hasError ? 'tw-ring-red-500' : 'tw-ring-gray-300'} tw-placeholder:text-gray-400 focus:tw-ring-2 focus:tw-ring-inset ${hasError ? 'focus:tw-ring-red-500' : 'focus:tw-ring-brand-green-light'} tw-outline-none tw-text-md sm:tw-leading-6 tw-h-9`}
            {...props}
        >
            {children}
        </select>
    );
});

export default Select;
